/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row } from 'reactstrap'

const PricingReview = ({ item }) => {
  const [pricing, setPricing] = useState({
    wholeSalePrice: '0',
    unitsPerCase: '0',
    RetailPrice: '0',
  })

  useEffect(() => {
    if (item) {
      const { wholeSalePrice, unitsPerCase, RetailPrice } = item
      setPricing({
        wholeSalePrice: wholeSalePrice || 0,
        unitsPerCase: unitsPerCase || 0,
        RetailPrice: RetailPrice || 0,
      })
    }
  }, [item])

  return (
    <Row>
      <Col xs={4}>
        <FormGroup>
          <p>Wholesale Base Price</p>
          <Input type="number" placeholder={pricing.wholeSalePrice} disabled />
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>Number of Units per Case</p>
          <Input type="number" placeholder={pricing.unitsPerCase} disabled />
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>Suggested Retail Price Per Unit</p>
          <Input type="number" placeholder={pricing.RetailPrice} disabled />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default PricingReview
